import React from 'react';

import ClientOnly from '@/components/client-only';

import LockTokenHistory from './history';
import ActionLock from './lock-token';
import SkeletonLockBox from './lock-token/Skeleton';
import { LockTokenProvider } from './LockContext';
import TotalLocked from './total-locked';
import SkeletonTotalLock from './total-locked/Skeleton';

const LockContent: React.FC = () => {
  return (
    <LockTokenProvider>
      <div className="mt-[70px] md:mt-5">
        <div className="flex flex-wrap gap-[20px]">
          <div className="w-[calc(45%-10px)] lg:w-full">
            <ClientOnly skeleton={<SkeletonTotalLock />}>
              <TotalLocked />
            </ClientOnly>
          </div>
          <div className="w-[calc(55%-10px)] lg:w-full">
            <ClientOnly skeleton={<SkeletonLockBox />}>
              <ActionLock />
            </ClientOnly>
          </div>
        </div>
        <LockTokenHistory />
      </div>
    </LockTokenProvider>
  );
};

export default LockContent;
